import {action} from "mobx";
import React from "react";
import orderService from "../services/orderService";
import generalReportService from "services/generalReportService";
import appStore from "./appStore";
import {b64DecodeToUrl} from "../utils/helpers";
import i18n from "../i18n";
class orderStore {
    @action createOrder = async params => {
        appStore.setLoading(true);
        const resultOfRequest = await orderService.createOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.setLoading(false);
            appStore.openErrorModal({content: resultOfRequest?.data?.message});
            return resultOfRequest;
        }
        await appStore.showSuccessMessage({
            content: resultOfRequest.data.message
        });
        appStore.setLoading(false);
        return resultOfRequest.data;
    };

    @action getOrderList = async params => {
        const resultOfRequest = await orderService.getOrderList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getOrder = async params => {
        const resultOfRequest = await orderService.getOrder(params);
        if (resultOfRequest.status === 400 && params?.hideError !== true) {
            appStore.openErrorModal({
                content: i18n.t("stores.order.getOrder.error", {ns: "common"})
            });
        }
        return resultOfRequest;
    };

    @action getOperationNotes = async params => {
        const resultOfRequest = await orderService.getOperationNotes(params);
        return resultOfRequest;
    };

    @action getTransferLogs = async params => {
        const resultOfRequest = await orderService.getTransferLogs(params);
        return resultOfRequest;
    };

    @action cancelDelivery = async params => {
        const resultOfRequest = await orderService.cancelDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.cancelDelivery.successMesageContent", {ns: "common"})
        });
        return resultOfRequest;
    };

    @action finishPreparation = async params => {
        const resultOfRequest = await orderService.finishPreparation(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.finishPreparation.successMesageContent", {ns: "common"})
        });
        return resultOfRequest;
    };

    @action approveDelivery = async params => {
        const resultOfRequest = await orderService.approveDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.approveDelivery.successMesageContent", {ns: "common"})
        });
        return resultOfRequest;
    };

    @action getRaportColumns = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await orderService.getReportColumns(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action getDeliveryOrdersReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await generalReportService.getDeliveryOrdersReport(params);
        await appStore.setLoading(false);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }

        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action updateOrderOperationNote = async params => {
        const resultOfRequest = await orderService.updateOrderOperationNote(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action passOrder = async params => {
        const resultOfRequest = await orderService.passOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action cancelOrder = async params => {
        const resultOfRequest = await orderService.cancelOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action cancelOrderByNumber = async params => {
        const resultOfRequest = await orderService.cancelOrderByNumber(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            const response = resultOfRequest.data;
            const resend = params?.resend == true;
            if (
                response?.newDelivery?.deliveryId &&
                response?.newDelivery?.deliveryState === "inQueue" &&
                resend
            ) {
                appStore.showSuccessMessage({
                    content: (
                        <>
                            {i18n.t("stores.order.cancelOrderByNumber.queuedDelivery", {
                                ns: "common"
                            })}
                        </>
                    )
                });
            }
            if (
                response?.newDelivery?.deliveryId &&
                response?.newDelivery?.deliveryState === "waiting" &&
                resend
            ) {
                appStore.showSuccessMessage({
                    content: (
                        <>
                            {i18n.t("stores.order.cancelOrderByNumber.assignedDelivery", {
                                ns: "common"
                            })}{" "}
                            <a href={`/orders/${response?.newDelivery?.deliveryId}`}>
                                {i18n.t("stores.order.cancelOrderByNumber.showDelivery", {
                                    ns: "common"
                                })}
                            </a>
                        </>
                    ),
                    duration: 5
                });
            }
        }
        return true;
    };

    @action splitOrder = async params => {
        const resultOfRequest = await orderService.splitOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action reOrder = async params => {
        const resultOfRequest = await orderService.reOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action updateStep = async params => {
        const resultOfRequest = await orderService.updateStep(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest;
    };
    @action triggerCallback = async params => {
        const resultOfRequest = await orderService.triggerCallback(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.triggerCallback.successMesageContent", {ns: "common"})
        });
        return true;
    };
    @action getAvailableCouriersForTransfer = async params => {
        //@TODO response status control must be in request
        const resultOfRequest = await orderService.getAvailableCouriersForTransfer(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action transferOrder = async params => {
        const resultOfRequest = await orderService.transferOrder(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.transferOrder.error", {ns: "common"})
        });
        return true;
    };

    @action trialStart = async params => {
        const resultOfRequest = await orderService.trialStart(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.transferOrder.error", {ns: "common"})
        });
        return true;
    };

    @action trialEnd = async params => {
        const resultOfRequest = await orderService.trialEnd(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.transferOrder.error", {ns: "common"})
        });
        return true;
    };

    @action removePreferredCourier = async params => {
        const resultOfRequest = await orderService.removePreferredCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.removePreferredCourier.successMesageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action updatePreferredCourier = async params => {
        const resultOfRequest = await orderService.updatePreferredCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.updatePreferredCourier.successMesageContent", {
                ns: "common"
            })
        });
        return true;
    };
    @action removeForceCourier = async params => {
        const resultOfRequest = await orderService.removeForceCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Zorunlu Kurye Silindi!"
        });
        return true;
    };

    @action updateForceCourier = async params => {
        const resultOfRequest = await orderService.updateForceCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Zorunlu Kurye Güncellendi!"
        });
        return true;
    };

    @action approveAssignRequest = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await orderService.approveAssignRequest(params);
        console.log(resultOfRequest);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action setOrderPreparation = async params => {
        const resultOfRequest = await orderService.setOrderPreparation(params);

        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action rejectAssignRequest = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await orderService.rejectAssignRequest(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action bulkChangeStatusEndDayReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await orderService.bulkChangeStatusEndDayReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.order.bulkChangeStatusEndDayReport.successMesageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action getPolylineBetweenLocations = async params => {
        const {from_points, to_points} = params;
        const fromPoints = `${from_points[0][0]},${from_points[0][1]}`;
        const toPointsString = to_points.map(point => `${point[0]},${point[1]}`).join(";");
        const pointString = `${fromPoints};${toPointsString}`;
        const resultOfRequest = await orderService.getPolylineBetweenLocations(pointString);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action getOrdersReportForCompany = async params => {
        const resultOfRequest = await orderService.getOrdersReportForCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };
}

export default new orderStore();
